import React from "react";
import { TRANSLATION_KEYS as T } from "@cadenza/i18n-core";
import { useLanguageContext } from "@cadenza/i18n-react";

import { FaPlus, FaTrash } from "react-icons/fa";

import RADHandlerRoot from "../RADHandler/RADHandlerRoot.jsx";
import RADSelector from "./RADSelector.jsx";
import { useRADManager } from "./RADManager.jsx";
import { CSButton, Bar } from "@cadenza/ui";

const RADManagerUI = () => {
  const { STRINGS = {} } = useLanguageContext() || {};
  const RAD = STRINGS[T.RAD] || "Role Activity Diagram";
  const ADD = (STRINGS[T.NEW] || "New") + " " + RAD;
  const DELETE = (STRINGS[T.DELETE] || "Delete") + " " + RAD;

  const {
    currentRAD,
    setCurrentRAD,
    handleNewRAD,
    handleDeleteRAD,
    handleDeleteAllRADs,
  } = useRADManager();

  const leftContent = (
    <div className="button-container small-buttons">
      <CSButton onClick={handleNewRAD}>
        <FaPlus className="cs-icon" title={ADD} aria-label={ADD} />
      </CSButton>
      <RADSelector />
      {currentRAD?.id && (
        <CSButton
          onClick={() => handleDeleteRAD(currentRAD.id)}
          title={DELETE}
          aria-label={DELETE}
        >
          <FaTrash className="cs-icon" title={DELETE} aria-label={DELETE} />
        </CSButton>
      )}
      <CSButton
        className="btn-nowrap-ellipsis"
        onClick={() => handleDeleteAllRADs()}
      >
        Delete All (Temporary)
      </CSButton>
    </div>
  );

  const centreContent = (
    <div className="centre-text">
      {RAD}: {currentRAD?.info?.name || ""}
    </div>
  );

  const rightContent = null;

  return (
    <>
      <div className="top-bar rad-bar">
        <Bar
          leftContent={leftContent}
          centreContent={centreContent}
          rightContent={rightContent}
        />
      </div>
      {currentRAD && (
        <RADHandlerRoot rad={currentRAD} setCurrentRAD={setCurrentRAD} />
      )}
    </>
  );
};

export default RADManagerUI;
